import { render, staticRenderFns } from "./detail-box.vue?vue&type=template&id=e49da5de&lang=pug&"
import script from "./detail-box.vue?vue&type=script&lang=js&"
export * from "./detail-box.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports